<header>
  <app-registration-header [logoSrc]="logoSrc" [title]="title"></app-registration-header>
</header>
<main>
  <router-outlet></router-outlet>
</main>
<footer>
  <app-footer></app-footer>
</footer>